//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'message_template'
let resource_name = 'plantilla de mensaje'
let resource_name_plural = 'plantillas de mensajes'

const categories = {
  ACCOUNT_UPDATE: "Actualización de la cuenta",
  ALERT_UPDATE: "Actualización de una alerta",
  APPOINTMENT_UPDATE: "Actualización de una cita",
  AUTO_REPLY: "Auto-Reply",
  ISSUE_RESOLUTION: "Resolución del problema",
  PAYMENT_UPDATE: "Actualización de pago",
  PERSONAL_FINANCE_UPDATE: "Actualización de finanzas personales",
  RESERVATION_UPDATE: "Actualización de la reserva",
  SHIPPING_UPDATE: "Actualización de envío",
  TRANSPORTATION_UPDATE: "Actualización en el transporte",
  TICKET_UPDATE: "Cambio en una entrada",
  TRANSACTIONAL: "Utilidad",
  MARKETING: "Marketing",
  AUTHENTICATION: "Autenticación"
}

const languages = {
  es: "Español",
  es_MX: "Español (Mex)",
  en: "Ingles"
}

const statuses = {
  APPROVED: "Aprobado",
  PENDING: "En revisión",
  REJECTED: "Rechazado"
}

let state = {
  whatsapp_accounts: []
}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
const actions = {
  async whatsapps ({ commit }, params) {
    try {
      commit('setWA', [])
      commit('setItems', [])
      let res = await Vue.request.get(`account/${params.account_id}/whatsapp_list`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setWA', res.data.resource)
        params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo cuentas de whatsapp.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuentas de whatsapp.`})
      console.error(e)
    }
  },
  async download_templates({commit}, params){
    let res = await Vue.request.get(`/whatsapp/${params.waba_id}/dowload_templates`,{params: params.params || {}})
    if(params.callback) {
      params.callback(res)
    }
  },
  async templates_metrics({commit}, params){
    let res = await Vue.request.get(`/whatsapp/${params.waba_id}/templates_metrics`,{params: params.params || {}})
    if(params.callback) {
      params.callback(res)
    }
  },
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`whatsapp/${params.waba_id}/${resource}s`, { params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource.map(el => {
          el.loading = false
          el.category_name = categories[el.category] || el.category
          el.language_name = languages[el.language] || el.language
          el.status = statuses[el.status] || el.status
          el.preview = "No disponible"
          if(el.components && el.components.length) {
            let body = el.components.find(el => el.type === 'BODY')
            if(body && body.text && body.text.length) {
              el.preview = body.text.length > 30 ? body.text.substring(0, 30) + '...' : body.text
            }
          }
          return el
        }))
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`whatsapp/${params.waba_id}/${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params.id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async updateTemplate ({ commit }, params) {
    try {
      const res = await Vue.request.patch(
        `/whatsapp_model/message_template/${params.params.wabaId}`,
        params
      )
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if (params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`whatsapp/${params.waba_id}/${resource}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params.id)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  removeItem (state, item_id) {
    let index = state[resource + 's'].findIndex(el => el.id === item_id)
    if (index >= 0) {
      state[resource + 's'].splice(index, 1)
    }
  },
  setWA (state, items) {
    state.whatsapp_accounts = items
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
